import * as R from 'ramda'
import KPI from './model/KPI'
import { makeObservable, observable } from 'mobx'
import { getTitle } from '../../../utils/QuestionHelper'

import Formula from './model/Formula'

class KpiStore {
    @observable dependencyQuestions = []

    @observable qlistQuestions = []

    @observable showTest = false

    kpiList = []

    @observable kpiDependencies = []

    @observable filteredKpis = []

    constructor(store) {
        this.store = store
        makeObservable(this)
    }

    save = async (kpi) => {
        // eslint-disable-next-line no-unused-expressions
        kpi.id === 0
            ? this.store.http.post('/kpi', JSON.stringify(kpi))
            : this.store.http.put(`/kpi/${kpi.id}`, JSON.stringify(kpi))
    }

    toggleTest = () => {
        console.log('toggleTest', this.showTest)
        this.showTest = !this.showTest
    }

    testKpi = async (surveyId, kpi) => {
        const { store } = this
        let kpiValue = []
        try {
            kpiValue = await store.http.post('/intranet/kpi/test', JSON.stringify({
                surveyId,
                kpi,
            }))
        } catch (e) {
            console.error(e)
            store.addNotification(null, 'Error testing kpi', 'error')
        }

        return kpiValue
    }

    addOption = (kpi) => {
        const formulae = kpi.formula.slice()
        formulae.push(new Formula({}))

        kpi.formula = formulae
    }

    changeFormula = (kpi, { value, id, name }) => {
        const formulae = kpi.formula.slice()
        const index = formulae.findIndex((formula) => id === formula.id)

        if (index >= 0) {
            formulae[index][name] = value
            kpi.formula = formulae
        }
    }

    removeOption = (kpi, formulaId) => {
        const formulae = kpi.formula.slice()
        const filteredFormulae = formulae.filter(({ id }) => id !== formulaId)

        kpi.formula = filteredFormulae.length > 0
            ? filteredFormulae
            : [new Formula({})]
    }

    removeVariable = (kpi, variableId) => {
        const variables = kpi.variables.slice()
        kpi.variables = variables.filter(({ id }) => id !== variableId)
    }
    /**
     * CreateEdit page
     */

    get = async (id) => {
        const { store } = this
        const { userData } = store
        const { clientId } = userData

        let kpi = {
            clientId,
        }

        try {
            if (id !== 0) {
                kpi = await this.store.http.get(`/kpi/${id}`)
            }
        } catch (e) {
            console.error(e)
            this.store.addNotification(null, `Error Loding KPI -> ${e.message}`, 'error')
        }

        return new KPI(kpi)
    }

    getQList = async (kpi) => {
        const {
            productType,
            surveyType,
            respondentType,
            industry,
        } = kpi

        let qlisturl = "/qlist/getAllQlists2?"
        qlisturl += "&productType=" + productType
        qlisturl += "&respondentType=" + respondentType
        qlisturl += "&surveyType=" + surveyType
        qlisturl += `&industry=${industry}`

        let questions = []

        try {
            questions = await this.store.http.get(qlisturl)
        } catch (e) {
            console.error(e)
        }

        const questionMap = {}

        this.qlistQuestions = questions.map((qlistQuestion) => {
            const { questionId, parentId } = qlistQuestion
            const question = JSON.parse(qlistQuestion.question)
            const { questionTypeCode } = question

            if (!R.isNil(parentId)) {
                const parentQuestion = questionMap[parentId.toUpperCase()]

                if (parentQuestion) {
                    if (parentQuestion.optionSet) {
                        const filteredParentOptions = R.pathOr([], ['optionSet', 'options'], parentQuestion)
                            .filter(({ isNonReporting }) => !isNonReporting)

                        if (question.optionSet) {
                            question.optionSet.options = [
                                ...filteredParentOptions,
                                ...question.optionSet.options,
                            ]
                        } else if (question.optionSetY) {
                            question.optionSetY.options = [
                                ...filteredParentOptions,
                                ...question.optionSetY.options,
                            ]
                        }
                    }
                }
            }

            const questionList = []

            const getLabel = (question) => (
                getTitle({
                    content: question.content.shortTitle,
                    locale: 'en_GB',
                    defaultLocale: question.metadata.initialLocale,
                }).text
            )

            if (questionTypeCode === 'FM') {
                const formLabel = getLabel(question)
                const formId = question.id.toUpperCase()
                question.optionSet.forEach(({ question }) => {
                    questionMap[question.id.toUpperCase()] = question

                    questionList.push({
                        value: question.id.toUpperCase(),
                        label: `${formLabel} - ${getLabel(question)}`,
                        formId,
                        question,
                    })
                })
            } else {
                questionMap[questionId.toUpperCase()] = question
                questionList.push({
                    value: questionId,
                    label: getLabel(question),
                    question,
                })
            }

            return questionList
        }).flat()
    }

    getKpis = async (kpi) => {
        const {
            productType,
            surveyType,
            respondentType,
            industry,
        } = kpi
        const kpis = await this.store.http.get('/kpi')
        this.kpiDependencies = kpis
            .filter((kpi) => (
                industry === kpi.industry
                && respondentType === kpi.respondentType
                && surveyType === kpi.surveyType
                && productType === kpi.productType
            ))
            .map((kpi) => ({
                value: kpi.kpiId,
                label: kpi.name,
            }))
    }
    /** end CreateEdit page */

    /**
     * Search page
     */
    search = async () => {
        const kpis = await this.store.http.get('/kpi')
        this.kpiList = kpis.map((kpi) => new KPI(kpi))
        this.filteredKpis = this.kpiList
    }

    filter = () => {
        const { searchStr } = this.searchModule
        const re = new RegExp(searchStr, 'i')
        const filteredData = R.isEmpty(searchStr)
            ? this.kpiList
            : this.kpiList.filter(({ kpiId, name }) => (
                kpiId.match(re)
                || name.match(re)
            ))

        this.filteredKpis = filteredData
    }

    delete = async (id) => {
        const { store } = this
        try {
            await store.http.delete(`/kpi/${id}`)
            this.kpiList = this.kpiList.filter((kpi) => kpi.id !== id)
            this.filteredKpis = this.filteredKpis.filter((kpi) => kpi.id !== id)

            store.addNotification(null, 'KPI deleted', 'success')
        } catch (e) {
            console.error(e)
            store.addNotification(null, 'Error deleting KPI', 'error')
        }
    }
    /** end Search page */

    getClients = async () => {
        const { store } = this
        const { userData } = store
        const { clientId, clientName } = userData

        return [{
            value: clientId,
            label: clientName,
        }]
    }
}

export default KpiStore
